import { usePLMapboxStoreV2 as t } from "./index.es6.js";
const r = (a) => {
  var e, o;
  return ((o = (e = t.getState().maps) == null ? void 0 : e[a]) == null ? void 0 : o.isMapboxLoaded) ?? !1;
};
export {
  r as checkIsMapLoaded
};
//# sourceMappingURL=index.es245.js.map
